'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../shortid/index.js
// module id = 644
// module chunks = 25